import React, { Component } from 'react';
import { styled } from '@mui/material/styles';
import {
    FormControl,
    InputLabel,
    Input,
    Button,
    Box,
} from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';

// Styled components replacing withStyles
const StyledFormControl = styled(FormControl)(({ theme }) => ({
    margin: theme.spacing(1),
}));

const StyledButton = styled(Button)(({ theme }) => ({
    margin: theme.spacing(1),
}));

class EmailLoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: ''
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        this.setState({
            email: target.value
        });
    }

    handleKeyDown(event) {
        if (event.key === 'Enter') {
            this.handleClick();
        }
    }

    handleClick() {
        const urlParams = new URLSearchParams(window.location.search);
        const eventId = urlParams.get('event_id');
        window.top.location =
            window.location.origin +
            '/index.php?p=remote&op=quickenter&event_id=' +
            eventId +
            '&member-email=' +
            this.state.email;
    }

    render() {
        return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <StyledFormControl fullWidth>
                    <InputLabel htmlFor="member-e-mail">E-MAIL:</InputLabel>
                    <Input
                        id="member-e-mail"
                        label="e-mail"
                        onChange={this.handleInputChange}
                        onKeyDown={this.handleKeyDown}
                    />
                </StyledFormControl>
                <StyledButton
                    variant="contained"
                    color="primary"
                    endIcon={<LoginIcon />}
                    onClick={this.handleClick}
                >
                    {this.props.buttonText}
                </StyledButton>
            </Box>
        );
    }
}

export default EmailLoginForm;
